"use client";
import { Box } from "@mui/material";
import OnChainWalletActivityTable from "./OnChainWalletActivityTable";
import WalletDetailTable from "./WalletDetailTable";


export default function WalletTablesRow({symbol}: {symbol: 'btc' | 'eth' | 'sol'}) {
  const containerHeight = "37rem";
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
        gap: 1,
        alignItems: "stretch",
        width: "100%",
        maxWidth: "100%",
        "& > *": { minWidth: 0 },
      }}>
      <OnChainWalletActivityTable symbol={symbol} containerHeight={containerHeight} />

      <Box sx={{ position: "relative", minWidth: 0 }}>
        {/* 视觉上在两表之间留出分隔 */}
        <WalletDetailTable symbol={symbol} containerHeight={containerHeight} />
      </Box>
    </Box>
  );
}
